/* eslint-disable @typescript-eslint/promise-function-async */
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const SummaryRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.SUMMARY.CONFIRMATION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/summary/confirmation/confirmation.module').then(m => m.ConfirmationPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.SUMMARY.OK.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/summary/ok/ok.module').then(m => m.OkPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.SUMMARY.KO.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/summary/ko/ko.module').then(m => m.KoPageModule),
    canActivate: [NavigationGuard],
  },
];
